import React, { useEffect, useRef, useState } from 'react';
import Loading from '../Loading';
import { ReactComponent as SearchMagnifyIcon } from '../../assets/svg/SearchMagnifyIcon.svg';
import CreateEditCourseModal from './CreateEditCourseModal';
import { useNavigate } from 'react-router-dom';
import { getCourseCategories, getCourses, getLocales } from '../../server/server';
import { fileSystemUrl } from '../../server/connections';
import FilterCourses from './FilterCourses';
import BigImageModal from '../modals/BigImageModal';
import SelectStringComponent from '../SelectStringComponent';
import ExportImportModal from './ExportImportModal';
import InfiniteScroll from 'react-infinite-scroll-component';

function CoursesHome() {
	const navigate = useNavigate();
	const [courses, setCourses] = useState<any[]>([]);
	const [allCourses, setAllCourses] = useState<any>([]);
	const [loading, setLoading] = useState(true);
	const [loadingCategories, setLoadingCategories] = useState(true);
	const [searchTerm, setSearchTerm] = useState('');
	const [createCourseModal, setCreateCourseModal] = useState(false);
	const [selectedCourse, setSelectedCourse] = useState<any | null>(null);
	const [categories, setCategories] = useState<any>([]);
	const [filterState, setFilterState] = useState('');
	const [imageModalOpen, setImageModalOpen] = useState(false);
	const [selectedImage, setSelectedImage] = useState('');
	const [locales, setLocales] = useState<any>([]);
	const [localesName, setLocalesName] = useState<string[]>([]);
	const [locale, setLocale] = useState('English');
	const [exportImportModalOpen, setExportImportModalOpen] = useState(false);
	const [search, setSearch] = useState('');
	const [loadingMore, setLoadingMore] = useState(false);
	const timeout = useRef<any>(null);
	const [resultsNum, setResultsNum] = useState(0);
	const [hasMore, setHasMore] = useState(true);
	const isFirstMount = useRef(true);

	useEffect(() => {
		loadCategories();
		loadLocales();
	}, []);

	useEffect(() => {
		if (isFirstMount.current) {
			isFirstMount.current = false;
			return;
		}
		if (resultsNum === 0) loadCourses();
		else setResultsNum(0);
	}, [filterState, locale]);

	useEffect(() => {
		console.log('resultsNum ', resultsNum);
		loadCourses();
	}, [resultsNum]);

	const loadCourses = async (searchTerm: string = search) => {
		if (resultsNum === 0) setLoading(true);
		else setLoadingMore(true);
		const resp = await getCourses({ limit: 6, offset: resultsNum, title: searchTerm, category: filterState, locale: filterLocale() });
		if (resp.status == 200) {
			const data = resp.data?.items;
			const total = resp.data?.total;
			if (resultsNum === 0) {
				setCourses(data);
				setHasMore(total > data?.length);
			} else {
				setHasMore(total > courses.length + data?.length);
				setCourses((prev: any) => [...prev, ...data]);
			}
			setLoadingMore(false);
			setLoading(false);
		} else {
			setLoading(false);
		}
	};

	const handleChange = (e: any) => {
		e.preventDefault();
		setSearch(e.target.value);
		if (timeout !== null) {
			clearTimeout(timeout.current);
		}
		timeout.current = setTimeout(() => {
			if (resultsNum === 0) loadCourses(e.target.value);
			else setResultsNum(0);
		}, 700);
	};

	const filterLocale = () => {
		const filterName: any[] = locales.filter((item: any) => locale === item.name);
		if (filterName.length !== 0) return filterName[0].code ?? '';
		else {
			return 'EN';
		}
	};

	const loadCategories = async () => {
		const resp = await getCourseCategories();
		if (resp.status === 200) {
			setCategories([...resp.data]);
			setLoadingCategories(false);
		} else {
			setLoadingCategories(false);
		}
	};

	const loadLocales = async () => {
		const resp = await getLocales();
		if (resp.status === 200) {
			setLocales(resp.data);
			let list = resp.data.map((item: any) => {
				return item.name;
			});
			setLocalesName(list);
		}
	};

	const openCourse = (course: any) => {
		navigate(`/courses/${course.id}`);
	};

	const closeCreateJournalModal = () => {
		setCreateCourseModal(false);
		setSelectedCourse(null);
	};

	const openImageModal = (image: string) => {
		setImageModalOpen(true);
		setSelectedImage(image);
	};

	const closeImageModal = () => {
		setImageModalOpen(false);
		setSelectedImage('');
	};

	const closeExportImportModal = async () => {
		setExportImportModalOpen(false);
	};

	return (
		<div id='scroll-inf-task' className='flex h-screen flex-col items-center overflow-y-auto bg-[#ECEBF8] py-[40px]'>
			<div className=' w-full  max-w-[1200px] px-[10px]'>
				<div className='w-full min-h-[calc(100vh-80px)]  bg-white flex flex-col px-[40px] py-[30px] rounded-[10px]'>
					<div className='mb-[30px] flex flex-row  items-end gap-4'>
						<p className='flex-1 text-[40px] leading-[50px] font-bold text-darkViolet'>Courses</p>
						<div
							className={`cursor-pointer flex h-[50px]  min-w-[180px] px-3 items-center justify-center rounded-full border border-primaryViolet
									bg-white text-[18px] leading-6  font-semibold text-primaryViolet transition  hover:bg-primaryViolet hover:text-brandYellow`}
							onClick={() => setExportImportModalOpen(true)}
						>
							Import / Export
						</div>
						<SelectStringComponent value={locale} selectedOption='English' setValue={setLocale} width={140} height={50} options={localesName} />
						<div
							className={`cursor-pointer flex h-[50px]  min-w-[180px] px-3 items-center justify-center rounded-full border border-primaryViolet
									bg-white text-[18px] leading-6  font-semibold text-primaryViolet transition  hover:bg-primaryViolet hover:text-brandYellow`}
							onClick={() => {
								setCreateCourseModal(true);
							}}
						>
							Add new course
						</div>
					</div>
					<div className=' flex w-full flex-row gap-5'>
						<div className='flex  h-[50px] flex-1 flex-row items-center rounded-full border border-primaryViolet  px-4'>
							<input type='text' placeholder='Search' value={search} onChange={(e: any) => handleChange(e)} className='h-full flex-1 rounded-full  outline-none  text-[18px] leading-6  font-semibold text-primaryViolet placeholder:font-medium placeholder:text-mudPurple' autoComplete='off' />
							<SearchMagnifyIcon />
						</div>
					</div>
					{!loadingCategories && <FilterCourses path={'/course-categories'} filterState={filterState} setFilterState={setFilterState} categories={categories} />}
					{courses.length === 0 && !loading && (
						<div className='flex w-full flex-grow  items-center justify-center'>
							<p className='text-center text-[14px] font-medium leading-5 text-mudPurple'>
								This list is empty right now.
								<br /> Consider adding new courses...
							</p>
						</div>
					)}
					{!loading && (
						<div>
							<InfiniteScroll
								dataLength={courses.length}
								next={() => {
									setResultsNum(courses.length);
								}}
								hasMore={hasMore}
								scrollableTarget='scroll-inf-task'
								inverse={false}
								loader={undefined}
							>
								{courses.map((course: any, index: number) => (
									<CourseButton course={course} openImageModal={openImageModal} openCourse={openCourse} key={course.id} />
								))}
							</InfiniteScroll>
						</div>
					)}
					{(loading || loadingMore) && (
						<div className='flex w-full flex-grow items-center justify-center'>
							<Loading size={70} primaryColor='#5E639B' stroke={3} />
						</div>
					)}
				</div>
			</div>
			<CreateEditCourseModal modalIsOpen={createCourseModal} closeModal={closeCreateJournalModal} course={selectedCourse} />
			<BigImageModal modalIsOpen={imageModalOpen} closeModal={closeImageModal} selectedImage={selectedImage} />
			<ExportImportModal modalIsOpen={exportImportModalOpen} closeModal={closeExportImportModal} />
		</div>
	);
}

export default CoursesHome;

const CourseButton = ({ course, openCourse, openImageModal }: { course: any; openCourse: any; openImageModal: any }) => {
	return (
		<div
			className='my-[5px] flex cursor-pointer flex-row gap-5 rounded-[10px] border border-[#F8F8FB] bg-[#F8F8FB] px-[40px] py-[25px] duration-300 ease-out hover:border-mudPurple'
			onClick={() => {
				openCourse(course);
			}}
			key={course.id}
		>
			{!!course.headlineImage && (
				<div
					className='w-full max-w-[160px] shrink-0'
					onClick={(e) => {
						e.preventDefault();
						e.stopPropagation();
						openImageModal(fileSystemUrl + '/' + course.headlineImage?.url);
					}}
				>
					<img className='h-[120px] w-full rounded-xl object-cover' src={fileSystemUrl + '/' + course.headlineImage?.url} alt={course?.title || 'Course image'} />
				</div>
			)}
			<div className='flex flex-1 flex-col justify-center'>
				<h3 className='text-[20px] font-semibold leading-7 text-primaryViolet'>{course.title}</h3>
				<p className='two-lines-of-text mt-[8px] text-[14px] font-medium leading-5 text-mudPurple'>{course.subtitle}</p>
			</div>
			<div className='flex w-[300px] shrink-0 flex-col justify-center gap-2'>
				<div className='flex flex-row items-center'>
					<span className='text-[16px] font-semibold leading-6 text-primaryViolet'>Locale:</span>
					<span className='ml-2 truncate text-[16px] font-medium leading-6 text-primaryViolet'>{course?.locale?.name || 'N/A'}</span>
				</div>
				<div className='flex flex-row items-center'>
					<span className='whitespace-nowrap text-[16px] font-semibold leading-6 text-primaryViolet'>Category:</span>
					<span className='ml-2 truncate text-[16px] font-medium leading-6 text-primaryViolet'>{course?.mainCategory?.name || 'N/A'}</span>
				</div>
			</div>
		</div>
	);
};
